import { render, staticRenderFns } from "./TransportRequestList.vue?vue&type=template&id=0678c328&scoped=true&"
import script from "./TransportRequestList.vue?vue&type=script&lang=js&"
export * from "./TransportRequestList.vue?vue&type=script&lang=js&"
import style0 from "./TransportRequestList.vue?vue&type=style&index=0&id=0678c328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678c328",
  null
  
)

export default component.exports